var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loading-layout"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spinner medium",attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":"88"}},[_c('div',{staticClass:"spinner-dot a"}),_c('div',{staticClass:"spinner-dot b"})])])
}]

export { render, staticRenderFns }